module.exports = __webpack_public_path__ + "static/media/5.95ed261d.png";